// Imports
import { useAppSelector } from '../shareables/foundation/front-end/redux/hooks';
import memberHasPrivilege from '../shareables/utils/member-has-privilege';
import { Privilege } from '../shareables/utils/privileges';


// Define the possible checks
export type MemberCheck =
	| { type: 'PRIVILEGE'; privilege: Privilege }
	| { type: 'ANY_PRIVILEGE' }
	| { type: 'MEMBER' }
	| { type: 'ACCOUNT_ISSUE' }
	| { type: 'HAS_ACCESS'; hasAccess: boolean };


/** Checks if the member has certain privileges or behaviors */
export default function useMemberCheck(check: MemberCheck): boolean {
	// Use Redux functionality
	const signedIn = useAppSelector((state) => state.common.user.signedIn);
	const member = useAppSelector((state) => state.self.member);
	const globalSignIn = useAppSelector((state) => state.self.globalSignIn);
	
	
	// Determine if user has an account issue
	if (check.type === 'ACCOUNT_ISSUE') {
		return signedIn && !globalSignIn && (!member?.account.approved || Boolean(member?.account.suspended));
	}
	
	
	// Determine if user can act as a member
	if (check.type === 'MEMBER') {
		return Boolean(member) || globalSignIn;
	}
	
	
	// Determine if user has the given access
	if (check.type === 'HAS_ACCESS') {
		return check.hasAccess || globalSignIn;
	}
	
	
	// Determine if user has any privilege, or the specific one given
	const memberPrivileges = member?.privileges ?? [];
	return (
		(check.type === 'ANY_PRIVILEGE'
			? memberPrivileges.length > 0
			: memberHasPrivilege(check.privilege, memberPrivileges)) || globalSignIn
	);
}
